import { Offer } from 'models';
import Points from 'components/Points';
import ImageWithLoader from 'components/ImageWithLoader';
import { useFeatureFlag } from 'providers';
import { promotions } from 'constants/promotions';
import { StyledCard, Footer, Text } from './OfferCard.styles';

interface OfferCardProps {
  active: boolean;
  displayBorder?: boolean;
  offer: Offer;
  onClick: (offer: Offer) => void;
  className?: string;
}

const { isSaleOfferPeriod } = promotions;

function OfferCard({ active, displayBorder = false, offer, onClick, className }: OfferCardProps) {
  const { imageUrl, title, points, originalPoints } = offer;
  const allowSaleOffers = useFeatureFlag('allowSaleOffers') && isSaleOfferPeriod;
  const isOnSale = displayBorder && allowSaleOffers && originalPoints !== undefined;

  const handleOnClick = () => {
    if (active) {
      onClick(offer);
    }
  };

  return (
    <StyledCard highlight={`${isOnSale}`} onClick={handleOnClick} className={className}>
      <ImageWithLoader src={imageUrl} alt={title} />
      <Footer>
        <Text variant="h6">{title}</Text>
        <Points points={points} originalPoints={originalPoints} />
      </Footer>
    </StyledCard>
  );
}

export default OfferCard;
